<template>
  <main class="contact-page">
    <section class="contact-hero">
      <span class="eyebrow">CONTACT & SUPPORT</span>
      <h1>联系我们</h1>
      <p>产品建议、场景需求、账户计费或环境故障，都可以在这里找到合适的反馈渠道。</p>
    </section>

    <section class="contact-grid">
      <article class="contact-card primary-card">
        <span class="card-icon">✉</span>
        <div>
          <small>电子邮箱</small>
          <h2>admin@azlinux.com</h2>
          <p>适合商务合作、隐私请求、退款咨询，以及需要补充附件的问题。</p>
          <a class="action primary" href="mailto:admin@azlinux.com?subject=azlinux.com%20用户咨询">发送邮件</a>
        </div>
      </article>

      <article class="contact-card">
        <span class="card-icon">⌁</span>
        <div>
          <small>站内支持</small>
          <h2>提交支持工单</h2>
          <p>环境创建、连接异常和场景模板需求，请尽量附上任务 ID、实例 ID 和报错信息。</p>
          <router-link class="action" to="/support-ticket">提交工单</router-link>
        </div>
      </article>
    </section>

    <section class="response-guide">
      <div>
        <h2>怎样能更快得到处理？</h2>
        <p>请避免发送账户密码、SSH 私钥、支付密码等敏感凭据。</p>
      </div>
      <ol>
        <li><strong>说明问题</strong><span>写清操作步骤、预期结果和实际现象。</span></li>
        <li><strong>提供线索</strong><span>附上发生时间、任务 ID、实例 ID 或错误截图。</span></li>
        <li><strong>保持可联系</strong><span>使用注册邮箱，便于核验账户并同步处理结果。</span></li>
      </ol>
    </section>
  </main>
</template>

<script>
export default { name: "ContactView" };
</script>

<style scoped>
.contact-page { min-height: calc(100vh - 70px); padding: 54px 24px 72px; background: #f4f7fb; color: #172235; text-align: left; }
.contact-hero, .contact-grid, .response-guide { width: min(1080px, 100%); margin-inline: auto; }
.contact-hero { padding: 28px 0 38px; }
.eyebrow { color: #2878d0; font-size: 12px; font-weight: 800; letter-spacing: .12em; }
.contact-hero h1 { margin: 9px 0 12px; font-size: clamp(34px, 5vw, 52px); letter-spacing: -.04em; }
.contact-hero p { max-width: 680px; margin: 0; color: #617084; font-size: 17px; line-height: 1.8; }
.contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.contact-card { display: flex; gap: 18px; min-height: 245px; padding: 30px; border: 1px solid #e2e9f1; border-radius: 16px; background: #fff; box-shadow: 0 8px 28px rgba(34, 64, 98, .06); }
.primary-card { border-color: #cfe1f5; background: linear-gradient(145deg, #fff, #f2f8ff); }
.card-icon { display: grid; place-items: center; width: 46px; height: 46px; flex: 0 0 46px; border-radius: 12px; background: #e9f3ff; color: #2474c7; font-size: 23px; font-weight: 800; }
.contact-card small { color: #7b8999; font-weight: 700; }.contact-card h2 { margin: 6px 0 12px; font-size: 22px; }.contact-card p { min-height: 58px; color: #68778a; line-height: 1.7; }
.action { display: inline-flex; margin-top: 9px; padding: 10px 18px; border: 1px solid #c9d5e2; border-radius: 9px; color: #2c5277; font-weight: 700; text-decoration: none; }.action.primary { border-color: #2878d0; background: #2878d0; color: #fff; }
.response-guide { display: grid; grid-template-columns: .85fr 1.4fr; gap: 48px; margin-top: 24px; padding: 34px; border: 1px solid #dbe6f1; border-radius: 16px; background: linear-gradient(145deg, #fff, #f5f9fd); color: #24384d; box-shadow: 0 8px 28px rgba(34, 64, 98, .05); }.response-guide h2 { margin: 0 0 10px; color: #1f3852; }.response-guide p { margin: 0; color: #68798b; line-height: 1.7; }.response-guide ol { display: grid; gap: 12px; margin: 0; padding: 0; list-style: none; }.response-guide li { display: grid; grid-template-columns: 100px 1fr; gap: 14px; padding: 12px 14px; border: 1px solid #e4ebf2; border-radius: 10px; background: rgba(255, 255, 255, .78); }.response-guide strong { color: #2878d0; }.response-guide span { color: #66778a; }
@media (max-width: 760px) { .contact-page { padding: 28px 14px 48px; }.contact-grid, .response-guide { grid-template-columns: 1fr; }.response-guide { gap: 24px; }.contact-card { min-height: auto; padding: 22px; }.response-guide li { grid-template-columns: 1fr; gap: 3px; } }
</style>
